import { ModuleConstants } from '@hrms/common/constant/modules';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';
import { lazy } from 'react';
import {
  ComponentsMapInterface,
  RouteConstantsInterface,
  ScreenNamesInterface,
} from '../types';

export enum ScreenNameEnums {
  PROFILE,
  PROFILE_HOME,
  VENDOR_ONBOARDING,
}

export enum RouteConstantEnums {
  PROFILE,
  PROFILE_HOME,
  VENDOR_ONBOARDING,
}

export enum ComponentEnum {
  PROFILE,
  VENDOR_ONBOARDING,
}

export const ScreenNames: ScreenNamesInterface = {
  PROFILE: 'Profile',
  PROFILE_HOME: 'Profile',
  VENDOR_ONBOARDING: 'Vendor Onboarding',
};

export const RouteConstants: RouteConstantsInterface = {
  PROFILE: '/profile/:id',
  PROFILE_HOME: '/profile',
  VENDOR_ONBOARDING: '/vendors/onboarding',
};

export enum ComponentsMapEnums {
  PROFILE,
  VENDOR_ONBOARDING,
}

export const ComponentsMap: ComponentsMapInterface = {
  PROFILE: lazy(() => import('../Profile')),
  VENDOR_ONBOARDING: lazy(() => import('../VendorOnboarding')),
};

const getProfileModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.PROFILE,
      route: RouteConstants.PROFILE_HOME,
      title: ScreenNames.PROFILE_HOME,
      sidebarVisibility: false,
      icon: generateImage({
        noScale: true,
        name: 'home-05',
        alt: 'Profile',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.PROFILE,
          route: RouteConstants.PROFILE,
          title: ScreenNames.PROFILE,
          sidebarVisibility: false,
          icon: generateImage({
            noScale: true,
            name: 'home-05',
            alt: 'Profile',
            className: 'w-4 h-4',
          }),
          component: ComponentsMap.PROFILE,
        },
      ],
    },
    {
      id: ModuleConstants.VENDOR_ONBOARDING,
      route: RouteConstants.VENDOR_ONBOARDING,
      title: ScreenNames.VENDOR_ONBOARDING,
      sidebarVisibility: false,
      icon: generateImage({
        noScale: true,
        name: 'home-05',
        alt: 'User Management Home',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.VENDOR_ONBOARDING,
    },
  ];
};

export default getProfileModuleRoutes;
